/**
 * True for a phone or tablet user agent (iOS, Android). iPadOS Safari reports a Mac user
 * agent, so a Macintosh with a touch screen counts as mobile too.
 */
export function isMobileUserAgent(userAgent, maxTouchPoints = 0) {
    const ua = String(userAgent || '');
    if (/iPhone|iPad|iPod|Android/i.test(ua)) {
        return true;
    }
    return /Macintosh/i.test(ua) && maxTouchPoints > 1;
}

/** Whether the running browser is a mobile one; false outside a browser context. */
export function isMobileBrowser() {
    if (typeof navigator === 'undefined') {
        return false;
    }
    return isMobileUserAgent(navigator.userAgent, navigator.maxTouchPoints);
}
